import xhr from "xhr";

type CsrfCallback = (error: Error | null) => void;

type CsrfTokenResponse = {
    token: string;
};

let pendingCallbacks: CsrfCallback[] | null = null;

/**
 * Pages render the CSRF token only for visitors who already have a session. For everyone else the token is fetched
 * (and the session created) right before the first mutation. Concurrent calls share a single fetch.
 */
export function withCsrfToken(callback: CsrfCallback) {
    if (window.panelCsrfToken) {
        callback(null);
        return;
    }

    if (pendingCallbacks) {
        pendingCallbacks.push(callback);
        return;
    }

    pendingCallbacks = [callback];

    //@ts-expect-error Fix later
    xhr({ url: "/api/csrf", method: "get", json: true }, (err, response) => {
        const callbacks = pendingCallbacks ?? [];
        pendingCallbacks = null;

        const body = response?.body as CsrfTokenResponse | undefined;
        let error: Error | null = err ?? null;

        if (!error && response.statusCode === 200 && body?.token) {
            window.panelCsrfToken = body.token;
        } else if (!error) {
            error = new Error(`Could not obtain CSRF token (${response.statusCode}).`);
        }

        callbacks.forEach(cb => cb(error));
    });
}
